<template lang="pug">
  section.section-2#service
    svg.red-line
      use(xlink:href="#red-line--sprite")
    .container-fluid(v-if="lang==='ru'")
      h2.title Услуги
      .service-list
        //- svg.service-list__bg-line
          use(xlink:href="#red-line--sprite")
        .service-list__wrapper
          .service-list__box
            .service-list__item(v-for="(text, key) in list1", :key="key")
              .service-list__item__wrapper
                .service-list__item--line
                  svg.service-list__item--svg
                    use(xlink:href="#red-line--sprite")
                .service-list__item--text {{text}}
    .container-fluid(v-if="lang==='en'")
      h2.title Services
      .service-list
        //- svg.service-list__bg-line
          use(xlink:href="#red-line--sprite")
        .service-list__wrapper
          .service-list__box
            .service-list__item(v-for="(text, key) in list2", :key="key")
              .service-list__item__wrapper
                .service-list__item--line
                  svg.service-list__item--svg
                    use(xlink:href="#red-line--sprite")
                .service-list__item--text {{text}}
</template>

<script>
  export default {
    name: 'Service',
    props: {
      lang: String
    },
    data() {
      return {
        list1: [
          'Транспортно-экспедиторское обслуживание и организация перевозок по РЖД и сопредельным государствам',
          'Предоставление железнодорожного подвижного состава и (или) контейнеров для осуществления перевозок',
          'Организация комплексных решений по перевозке продукции предприятий лесопромышленного комплекса, нефтехимической и автомобильной промышленности, товаров повседневного спроса',
          'Услуги по проектированию и оптимизации управления системы контейнерных перевозок клиента'
        ],
        list2: [
          'Freight-forwarding services and railway transportation in Russia and neighboring states',
          'Operational lease of rolling stock and containers',
          'Integrated logistics solutions with focus in consumer goods, timber, petrochemicals & automotive industries',
          'Design and optimization of container logistics'
        ]
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../style/variables";

  .section-2 {
    position: relative;
    margin-top: 6.4vw;
    .red-line {
      $s: 15vw;
      top: -($s / 2.5);
      left: -($s / 5);
      width: $s;
      height: $s;
      position: absolute;
    }
  }

  .title {
    margin-bottom: 0;
    font-size: 2.8vw;
    padding: 4.2vw 0 1.8vw;
    color: $color-title-red
  }

  .container-fluid {
    padding-bottom: 7.5vh;
  }

  .service-list {
    position: relative;
    &:before {
      top: 0;
      content: '';
      left: -$container-gutter-width;
      position: absolute;
      width: 40vw;
      height: 100%;
      background: url("~@/assets/cargo.jpg") no-repeat;
      background-size: cover;
    }
    &__bg-line {
      $s: 10.5vw;
      width: 10vw;
      height: 10vw;
      position: absolute;
      left: 16.1vw;
      bottom: -3.2vw;
    }
    &__wrapper {
      display: flex;
      padding: 2.6vw 0;
      justify-content: flex-end;
    }
    &__box {
      z-index: 1;
      width: 56vw;
      display: flex;
      padding: 3vw;
      flex-wrap: wrap;
      position: relative;
      background-color: white;
      box-shadow: $shadow;
    }
    &__item {
      $line-size: 2.9vw;
      width: 50%;
      flex: 0 0 50%;
      padding: 3.5vw;
      &__wrapper {
        display: flex;
        position: relative;
      }
      &--line {
        width: $line-size;
        height: $line-size;
        top: 0;
        left: -($line-size + .6vw);
        position: absolute;
      }
      &--svg {
        width: $line-size;
        height: $line-size;
      }
    }
  }

</style>
